import React from "react";

const WhoWeAre = () => {
  return (
    <div className="py-16 sm:py-20 flex justify-center items-center bg-gradient-to-r from-green-800 to-green-600 text-white">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold tracking-tight ">
          <span class="text-primary">Who</span> We <span class="underline underline-offset-8 decoration-[#2db928] ml-3">Are</span>
        </h2>
        <p className="mt-6 text-base md:text-lg lg:text-xl leading-6 md:leading-8 ">
          Welcome to NextEra Research A SEBI-registered  Research Analyst primary goal is to provide investors with accurate and unbiased research reports on securities, commodities, and currencies. This includes analyzing financial performance, market trends, and investment prospects, ultimately helping investors make informed decisions. The Research Analyst also aims to ensure compliance with SEBI regulations, protecting investors and maintaining ethical standards.
        </p>
      </div>
    </div>
  );
};

export default WhoWeAre;
